<template>
    <div class="p-3">
        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>

            <div class="col-sm-2">
                <div class="mb-3 row">
                    <label
                        for="tanggal_dari"
                        class="col-sm-4 col-form-label text-end"
                    >
                        Dari
                    </label>

                    <div class="col-sm-8">
                        <input
                            type="date"
                            id="tanggal_dari"
                            class="form-control"
                            v-model="filter.tanggal_dari"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="mb-3 row">
                    <label
                        for="tanggal_sampai"
                        class="col-sm-4 col-form-label text-end"
                    >
                        Sampai
                    </label>

                    <div class="col-sm-8">
                        <input
                            type="date"
                            id="tanggal_sampai"
                            class="form-control"
                            v-model="filter.tanggal_sampai"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label
                        for="ruangan"
                        class="col-sm-4 col-form-label text-end"
                    >
                        Ruang Rawat
                    </label>

                    <div class="col-sm-8">
                        <select
                            id="ruangan"
                            class="form-select"
                            v-model="filter.ruangan"
                        >
                            <option value="">-- Semua Ruangan --</option>

                            <option
                                v-for="(kamar, index) in data_kamar"
                                :key="`${kamar.KDKelas}-${index}`"
                                :value="kamar.KDKelas"
                            >
                                {{ kamar.NmBangsal + "/" + kamar.NMKelas }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label
                        for="status_pasien"
                        class="col-sm-4 col-form-label text-end"
                    >
                        Status
                    </label>

                    <div class="col-sm-8">
                        <select
                            id="status_pasien"
                            class="form-select"
                            v-model="filter.status_pasien"
                        >
                            <option value="">-- Semua Status --</option>
                            <option value="masuk">Masuk</option>
                            <option value="dirawat">Dirawat</option>
                            <option value="pindah">Pindah</option>
                            <option value="pulang">Pulang</option>
                            <option value="meninggal">Meninggal</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-sm-5">
                <div class="mb-3 row">
                    <label
                        for="search"
                        class="col-sm-5 col-form-label text-end"
                    >
                        No. RM/Nama/NIK/No Kartu BPJS
                    </label>

                    <div class="col-sm-7">
                        <input
                            type="text"
                            id="search"
                            class="form-control"
                            v-model="filter.search"
                            @keyup.enter="searchData"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="mb-3">
                    <div class="d-flex gap-2">
                        <button
                            type="button"
                            class="btn btn-danger"
                            :disabled="loading"
                            @click="resetFilters"
                        >
                            <i class="fa fa-refresh"></i>
                            Reset
                        </button>

                        <button
                            type="button"
                            class="btn btn-primary"
                            :disabled="loading"
                            @click="searchData"
                        >
                            <span
                                v-if="loading"
                                class="spinner-border spinner-border-sm me-1"
                            ></span>

                            <i v-else class="fa fa-search me-1"></i>

                            Cari
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Sensus Harian</div>

            <div class="card-body position-relative">
                <div v-if="loading" class="loading-overlay">
                    <div class="text-center">
                        <div
                            class="spinner-border text-primary"
                            role="status"
                        ></div>

                        <div class="mt-2">Memuat data...</div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-bordered sensus-table mb-0">
                        <thead>
                            <tr>
                                <th rowspan="2">No.</th>

                                <th rowspan="2">No. RM</th>

                                <th rowspan="2">Nama Pasien</th>

                                <th colspan="2" class="text-center">Usia</th>

                                <th rowspan="2">Tgl Masuk</th>

                                <th rowspan="2">Tgl Keluar</th>

                                <th rowspan="2">Hari Rawat</th>

                                <th rowspan="2">Status Pasien</th>

                                <th rowspan="2">Alamat</th>

                                <th rowspan="2">Detail</th>
                            </tr>

                            <tr>
                                <th>L</th>
                                <th>P</th>
                            </tr>
                        </thead>

                        <tbody v-if="groups.length">
                            <template v-for="room in groups">
                                <tr :key="`room-${room.key}`" class="room-row">
                                    <td colspan="11">
                                        Ruangan:
                                        <strong>
                                            {{ room.name }}
                                        </strong>
                                    </td>
                                </tr>

                                <template v-for="payment in room.payments">
                                    <tr
                                        :key="`payment-${room.key}-${payment.key}`"
                                        class="payment-row"
                                    >
                                        <td colspan="11">
                                            Cara Bayar:
                                            <strong>
                                                {{ payment.name }}
                                            </strong>
                                        </td>
                                    </tr>

                                    <tr
                                        v-for="row in payment.rows"
                                        :key="row.Regno"
                                    >
                                        <td class="text-center">
                                            {{ row.nomor }}.
                                        </td>

                                        <td>
                                            {{ showValue(row.Medrec) }}
                                        </td>

                                        <td>
                                            {{ showValue(row.Firstname) }}
                                        </td>

                                        <td>
                                            {{ showValue(row.umur_l) }}
                                        </td>

                                        <td>
                                            {{ showValue(row.umur_p) }}
                                        </td>

                                        <td>
                                            {{ showValue(row.tanggal_masuk) }}
                                        </td>

                                        <td>
                                            {{ showValue(row.tanggal_keluar) }}
                                        </td>

                                        <td>
                                            {{ showValue(row.hari_rawat) }}
                                        </td>

                                        <td>
                                            <span
                                                class="badge"
                                                :class="
                                                    statusClass(
                                                        row.status_pasien
                                                    )
                                                "
                                            >
                                                {{
                                                    showValue(row.status_pasien)
                                                }}
                                            </span>
                                        </td>

                                        <td>
                                            {{ showValue(row.alamat) }}
                                        </td>

                                        <td class="text-center">
                                            <button
                                                type="button"
                                                class="btn btn-primary btn-sm"
                                                @click="openDetail(row)"
                                            >
                                                <i class="fa fa-eye"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>

                        <tbody v-else-if="!loading">
                            <tr>
                                <td
                                    colspan="11"
                                    class="text-center text-muted py-4"
                                >
                                    Tidak ada data pasien.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div
                    v-if="pagination.total > 0"
                    class="d-flex justify-content-between align-items-center mt-3"
                >
                    <div class="text-muted small">
                        Menampilkan
                        {{ pagination.from }}
                        -
                        {{ pagination.to }}
                        dari
                        {{ pagination.total }}
                        pasien
                    </div>

                    <div class="d-flex align-items-center gap-2">
                        <select
                            class="form-select form-select-sm page-size"
                            v-model.number="pagination.per_page"
                            @change="changeSize"
                        >
                            <option :value="10">10</option>

                            <option :value="20">20</option>

                            <option :value="50">50</option>
                        </select>

                        <button
                            class="btn btn-sm btn-outline-secondary"
                            :disabled="loading || pagination.current_page <= 1"
                            @click="changePage(pagination.current_page - 1)"
                        >
                            <i class="fa fa-chevron-left"></i>
                        </button>

                        <span class="small">
                            Halaman
                            {{ pagination.current_page }}
                            /
                            {{ pagination.last_page }}
                        </span>

                        <button
                            class="btn btn-sm btn-outline-secondary"
                            :disabled="
                                loading ||
                                pagination.current_page >= pagination.last_page
                            "
                            @click="changePage(pagination.current_page + 1)"
                        >
                            <i class="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="modal-detail-pasien"
            tabindex="-1"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Detail Sensus Pasien</h5>

                        <button
                            type="button"
                            class="btn-close btn-close-white"
                            data-bs-dismiss="modal"
                        ></button>
                    </div>

                    <div class="modal-body">
                        <div v-if="loadingDetail" class="text-center py-5">
                            <div class="spinner-border text-primary"></div>

                            <div class="mt-2">Memuat detail pasien...</div>
                        </div>

                        <template v-else-if="detail">
                            <div class="row g-3">
                                <div
                                    v-for="item in detailFields"
                                    :key="item.label"
                                    class="col-md-4"
                                >
                                    <div class="detail-item">
                                        <div class="detail-label">
                                            {{ item.label }}
                                        </div>

                                        <div class="detail-value">
                                            {{ showValue(item.value) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <h6 class="fw-bold mb-3">
                                Riwayat Perpindahan Ruangan
                            </h6>

                            <div class="table-responsive">
                                <table class="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Waktu Pindah</th>
                                            <th>Ruangan</th>
                                            <th>Kelas</th>
                                        </tr>
                                    </thead>

                                    <tbody
                                        v-if="
                                            detail.riwayat_pindah &&
                                            detail.riwayat_pindah.length
                                        "
                                    >
                                        <tr
                                            v-for="(
                                                pindah, index
                                            ) in detail.riwayat_pindah"
                                            :key="`${pindah.NoPindah}-${index}`"
                                        >
                                            <td>
                                                {{ index + 1 }}
                                            </td>

                                            <td>
                                                {{
                                                    showValue(
                                                        pindah.waktu_pindah
                                                    )
                                                }}
                                            </td>

                                            <td>
                                                {{
                                                    showValue(pindah.NmBangsal)
                                                }}
                                            </td>

                                            <td>
                                                {{ showValue(pindah.NMKelas) }}
                                            </td>
                                        </tr>
                                    </tbody>

                                    <tbody v-else>
                                        <tr>
                                            <td
                                                colspan="4"
                                                class="text-center text-muted"
                                            >
                                                Tidak ada perpindahan ruangan.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <hr />

                            <h6 class="fw-bold mb-3">Informasi Biaya</h6>

                            <div class="row g-3">
                                <div
                                    v-for="item in billingFields"
                                    :key="item.label"
                                    class="col-md-3"
                                >
                                    <div class="detail-item">
                                        <div class="detail-label">
                                            {{ item.label }}
                                        </div>

                                        <div class="detail-value">
                                            {{ formatCurrency(item.value) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Tutup
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as bootstrap from "bootstrap";

export default {
    name: "PasienRawat",

    data() {
        return {
            loading: false,
            loadingDetail: false,
            data_kamar: [],
            rows: [],
            detail: null,
            detailModal: null,
            filter: {
                tanggal_dari: "",
                tanggal_sampai: "",
                ruangan: "",
                status_pasien: "",
                search: "",
            },
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 20,
                from: null,
                to: null,
                total: 0,
            },
        };
    },

    computed: {
        groups() {
            const rooms = {};

            this.rows.forEach((row, index) => {
                const roomName = row.NmBangsal || row.ruang_kelas || "-";

                const paymentName = row.NMCbayar || "-";

                if (!rooms[roomName]) {
                    rooms[roomName] = {
                        key: roomName,
                        name: roomName,
                        payments: {},
                    };
                }

                if (!rooms[roomName].payments[paymentName]) {
                    rooms[roomName].payments[paymentName] = {
                        key: paymentName,
                        name: paymentName,
                        rows: [],
                    };
                }

                rooms[roomName].payments[paymentName].rows.push({
                    ...row,
                    nomor:
                        (this.pagination.current_page - 1) *
                            this.pagination.per_page +
                        index +
                        1,
                });
            });

            return Object.values(rooms).map((room) => ({
                ...room,
                payments: Object.values(room.payments),
            }));
        },

        detailFields() {
            if (!this.detail) {
                return [];
            }

            return [
                {
                    label: "No. Registrasi",
                    value: this.detail.Regno,
                },
                {
                    label: "No. RM",
                    value: this.detail.Medrec,
                },
                {
                    label: "Nama Pasien",
                    value: this.detail.Firstname,
                },
                {
                    label: "Jenis Kelamin",
                    value: this.detail.gender,
                },
                {
                    label: "Umur",
                    value: this.detail.umur,
                },
                {
                    label: "Status Sensus",
                    value: this.detail.status_pasien,
                },
                {
                    label: "Tanggal Masuk",
                    value: this.detail.waktu_masuk,
                },
                {
                    label: "Tanggal Keluar",
                    value: this.detail.waktu_keluar,
                },
                {
                    label: "Hari Rawat",
                    value: this.detail.hari_rawat,
                },
                {
                    label: "Poli Asal",
                    value: this.detail.NMPoli,
                },
                {
                    label: "Ruangan Sensus",
                    value: this.detail.ruang_kelas,
                },
                {
                    label: "No. Kamar",
                    value: this.detail.nokamar,
                },
                {
                    label: "No. Tempat Tidur",
                    value: this.detail.NoTTidur,
                },
                {
                    label: "DPJP",
                    value: this.detail.NmDocRS,
                },
                {
                    label: "Cara Bayar",
                    value: this.detail.NMCbayar,
                },
                {
                    label: "No. SEP",
                    value: this.detail.nosep,
                },
                {
                    label: "Cara Keluar",
                    value: this.detail.cara_keluar,
                },
                {
                    label: "Kondisi Keluar",
                    value: this.detail.kondisi_keluar,
                },
                {
                    label: "Alamat",
                    value: this.detail.alamat,
                },
            ];
        },

        billingFields() {
            if (!this.detail) {
                return [];
            }

            return [
                {
                    label: "Pagu",
                    value: this.detail.pagu,
                },
                {
                    label: "Realisasi",
                    value: this.detail.realisasi,
                },
                {
                    label: "Kamar",
                    value: this.detail.bilRoom,
                },
                {
                    label: "Rawat Inap",
                    value: this.detail.bilIrna,
                },
                {
                    label: "Laboratorium",
                    value: this.detail.bilLab,
                },
                {
                    label: "Radiologi",
                    value: this.detail.bilRad,
                },
                {
                    label: "Operasi",
                    value: this.detail.bilOp,
                },
                {
                    label: "Obat",
                    value: this.detail.bilObat,
                },
                {
                    label: "Fisioterapi",
                    value: this.detail.bilFis,
                },
                {
                    label: "BHP",
                    value: this.detail.bilBhp,
                },
                {
                    label: "HD",
                    value: this.detail.bilHd,
                },
                {
                    label: "VK",
                    value: this.detail.bilVk,
                },
                {
                    label: "Tindakan",
                    value: this.detail.bilTd,
                },
                {
                    label: "UGD",
                    value: this.detail.bilUgd,
                },
                {
                    label: "Uang Muka",
                    value: this.detail.uangMuka,
                },
            ];
        },
    },

    created() {
        const today = this.getToday();

        this.filter.tanggal_dari = today;
        this.filter.tanggal_sampai = today;
    },

    mounted() {
        this.getKamarRawat();

        this.$nextTick(() => {
            const modalElement = document.getElementById("modal-detail-pasien");

            if (modalElement) {
                this.detailModal = new bootstrap.Modal(modalElement);
            }
        });

        this.getAllPasien();
    },

    beforeDestroy() {
        if (this.detailModal) {
            this.detailModal.dispose();
            this.detailModal = null;
        }
    },

    methods: {
        getToday() {
            const now = new Date();

            const year = now.getFullYear();

            const month = String(now.getMonth() + 1).padStart(2, "0");

            const day = String(now.getDate()).padStart(2, "0");

            return `${year}-${month}-${day}`;
        },

        async getKamarRawat() {
            try {
                const response = await this.axios.get(
                    "/api/pasien-dirawat/get-kamar-rawat"
                );

                this.data_kamar = response.data.data_ruangan || [];
            } catch (error) {
                this.data_kamar = [];
                console.error(error);
            }
        },

        async getAllPasien() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            try {
                const response = await this.axios.get(
                    "/api/pasien-dirawat/get-all",
                    {
                        params: {
                            page: this.pagination.current_page,
                            size: this.pagination.per_page,
                            tanggal_dari: this.filter.tanggal_dari,
                            tanggal_sampai: this.filter.tanggal_sampai,
                            ruangan: this.filter.ruangan,
                            status_pasien: this.filter.status_pasien,
                            search: this.filter.search,
                        },
                    }
                );

                const pagination = response.data.data_pasien || {};

                this.rows = Array.isArray(pagination.data)
                    ? pagination.data
                    : [];

                this.pagination.current_page = Number(
                    pagination.current_page || 1
                );

                this.pagination.last_page = Number(pagination.last_page || 1);

                this.pagination.from = pagination.from;

                this.pagination.to = pagination.to;

                this.pagination.total = Number(pagination.total || 0);
            } catch (error) {
                this.rows = [];

                this.pagination.from = null;
                this.pagination.to = null;
                this.pagination.total = 0;
                this.pagination.last_page = 1;

                console.error(error);

                if (this.$swal) {
                    this.$swal.fire({
                        icon: "error",
                        title: "Gagal",
                        text:
                            error.response?.data?.message ||
                            error.message ||
                            "Gagal mengambil data sensus.",
                    });
                }
            } finally {
                this.loading = false;
            }
        },

        searchData() {
            if (
                this.filter.tanggal_dari &&
                this.filter.tanggal_sampai &&
                this.filter.tanggal_dari > this.filter.tanggal_sampai
            ) {
                if (this.$swal) {
                    this.$swal.fire({
                        icon: "warning",
                        title: "Peringatan",
                        text: "Tanggal dari tidak boleh lebih besar dari tanggal sampai.",
                    });
                }

                return;
            }

            this.pagination.current_page = 1;
            this.getAllPasien();
        },

        resetFilters() {
            const today = this.getToday();

            this.filter = {
                tanggal_dari: today,
                tanggal_sampai: today,
                ruangan: "",
                status_pasien: "",
                search: "",
            };

            this.pagination.current_page = 1;
            this.pagination.per_page = 20;

            this.getAllPasien();
        },

        changePage(page) {
            if (
                page < 1 ||
                page > this.pagination.last_page ||
                page === this.pagination.current_page
            ) {
                return;
            }

            this.pagination.current_page = page;

            this.getAllPasien();
        },

        changeSize() {
            this.pagination.current_page = 1;
            this.getAllPasien();
        },

        async openDetail(row) {
            this.detail = null;
            this.loadingDetail = true;

            if (this.detailModal) {
                this.detailModal.show();
            }

            try {
                const response = await this.axios.get(
                    "/api/pasien-dirawat/get-detail",
                    {
                        params: {
                            Regno: row.Regno,
                            tanggal_dari: this.filter.tanggal_dari,
                            tanggal_sampai: this.filter.tanggal_sampai,
                        },
                    }
                );

                this.detail = response.data.data_pasien || null;
            } catch (error) {
                console.error(error);

                if (this.$swal) {
                    this.$swal.fire({
                        icon: "error",
                        title: "Gagal",
                        text:
                            error.response?.data?.message ||
                            error.message ||
                            "Gagal mengambil detail pasien.",
                    });
                }
            } finally {
                this.loadingDetail = false;
            }
        },

        statusClass(status) {
            const value = String(status || "").toLowerCase();

            if (value.includes("meninggal")) {
                return "bg-dark";
            }

            if (value.includes("pulang")) {
                return "bg-success";
            }

            if (value.includes("pindah")) {
                return "bg-warning text-dark";
            }

            if (value.includes("masuk")) {
                return "bg-primary";
            }

            return "bg-info text-dark";
        },

        showValue(value) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }

            return value;
        },

        formatCurrency(value) {
            const number = Number(value || 0);

            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(number);
        },
    },
};
</script>

<style scoped>
.card-body {
    min-height: 220px;
}

.loading-overlay {
    position: absolute;
    z-index: 100;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 220px;
    background: rgba(255, 255, 255, 0.78);
}

.sensus-table {
    min-width: 1350px;
    font-size: 0.84rem;
}

.sensus-table th {
    padding: 9px 8px;
    vertical-align: middle;
    background: #fff;
}

.sensus-table td {
    padding: 8px;
    vertical-align: middle;
}

.room-row td {
    background: #f5f5f5;
    font-weight: 600;
}

.payment-row td {
    background: #fafafa;
    font-weight: 600;
}

.page-size {
    width: 80px;
}

.detail-item {
    height: 100%;
    padding: 12px;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    background: #fff;
}

.detail-label {
    margin-bottom: 5px;
    color: #6c757d;
    font-size: 0.78rem;
}

.detail-value {
    color: #212529;
    font-weight: 600;
    word-break: break-word;
}
</style>
